/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMemo } from 'react';

import { useRouter } from 'next/router';
import Head from 'next/head';
import { AppProps } from 'next/app';

import { PublicLayout } from '~/layouts/public';
import { PrivateLayout } from '~/layouts/private';

import { GlobalStyle } from '~/common/styles/global';
import { ProvidersHOC } from '~/common/providers';
import { IFCWithChildren } from '~/common/interfaces/i-fc-with-childrent';
import { WhatsappFloatingButton } from '~/common/components/WhatsappFloatingButton';

const BareLayout: IFCWithChildren = ({ children }) => <>{children}</>;

function ValidateUrl() {
  if (typeof window !== 'undefined') {
    let urlUpdated = false;
    let url = window.location.href;

    // Redirect to HTTPS
    if (url.substr(0, 5) !== 'https' && !url.includes('localhost')) {
      url = url.replace('http', 'https');
      urlUpdated = true;
    }

    // Redirect from www to non-www
    if (url.includes('www.')) {
      url = url.replace('www.', '');
      urlUpdated = true;
    }

    if (urlUpdated) {
      window.location.href = url;
    }
  }
}

function PromptXApp({ Component, pageProps }: AppProps) {
  ValidateUrl();
  const router = useRouter();
  const basePath = router.asPath.includes('?')
    ? router.asPath.split('?')[0]
    : router.asPath;
  const bareRoutes = ['/privacy-policy', '/terms-of-service'];
  const isBareRoute = bareRoutes.includes(basePath);

  const Layout: IFCWithChildren = useMemo(() => {
    const privateRoutes = [
      'prompts',
      'categories',
      'users',
      'admin',
      'account',
      'saved',
      'training',
    ];

    if (isBareRoute) {
      return BareLayout;
    }

    const isPrivate = privateRoutes.some(
      (route) =>
        basePath.replace('/', '').includes(route) && !basePath.includes('login')
    );

    return isPrivate ? PrivateLayout : PublicLayout;
  }, [basePath, isBareRoute]);

  return (
    <>
      <Head>
        <link rel="manifest" href="/manifest.json" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />

        <meta name="theme-color" content="#ffffff" />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon/favicon.ico"
        />

        <meta
          name="google-site-verification"
          content="ClbhDXhggKzyBQOLY4qTdrbhm6Q8vuDHjoIm5iXKbL8"
        />

        <title>PromptX</title>
      </Head>

      <GlobalStyle />
      {isBareRoute ? (
        <Layout>
          <Component {...pageProps} />
        </Layout>
      ) : (
        <ProvidersHOC>
          <Layout>
            <Component {...pageProps} />
          </Layout>
          <WhatsappFloatingButton />
        </ProvidersHOC>
      )}
    </>
  );
}

export default PromptXApp;
